import { render, staticRenderFns } from "./fooddetail.vue?vue&type=template&id=a8122bec&scoped=true"
import script from "./fooddetail.vue?vue&type=script&lang=js"
export * from "./fooddetail.vue?vue&type=script&lang=js"
import style0 from "./fooddetail.vue?vue&type=style&index=0&id=a8122bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8122bec",
  null
  
)

export default component.exports